import React from "react"
import LxHeader from "@/components/LxHeader/One"
import LxSwiper from "@/components/LxSwiper"
import styles from "./index.module.scss"
import media from "./media.module.scss"
import { swiperList, brandList, lifeList, youngList } from "@/constants"
import Brands from "./cmp/Brands"
import { stopZoom, isMobile } from '@/utils/util'
import defaultSetting from '@/setting'
import LifeYoung from "./cmp/LifeYoung"
const yiqiLogo = require("@/assets/images/logo_yiqi_xiankuang.png")
// const companyPic01 = require("@/assets/images/pic.jpg")
const pic01 = require("@/assets/images/home/01.png")
const pic02 = require("@/assets/images/home/02.png")
const pic03 = require("@/assets/images/home/03.jpg")

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      swipers: [],
      isOpen: true,
      currentLifeIdx: 0,
      lifePics: [pic01, pic02, pic03],
      currentYoungIdx: 0,
      youngVideos: [
        // "https://video.hotjob.cn/a0dd5a0f8a2d71f0a17b4531958d0102/16cc61074e5c40e0a6acff5db295dc27-fcba6efb1df92d62f12cd4eee51f2f58-ld.mp4",
        "https://video.hotjob.cn/b0b1530f8a2d71f0bdda5420848c0102/82305a3803ab4ddea7178ea9a74789b7-4696b175b41d00a5284f88303299173e-ld.mp4",
        "https://video.hotjob.cn/b0b1530f8a2d71f0bdda5420848c0102/82305a3803ab4ddea7178ea9a74789b7-4696b175b41d00a5284f88303299173e-ld.mp4",
        "https://video.hotjob.cn/4082570f8a2d71f080bc6733a78e0102/bb37dc71cb97471ab1fb34194e05c412-50e9a5dc915a3d429b6b037543240934-ld.mp4"
      ],
    //   time: null,
    }
  }

  componentWillMount() {
    // 终端判断
    if (isMobile()) {
      this.props.history.push('/mobile/home');
    }

    if (defaultSetting.grayscale) {
      document.querySelector('html').classList.add('grayscale');
    }
  }

  componentDidMount() {
    stopZoom()
    // window.addEventListener("scroll", this.handleScroll)
  }
  // componentWillUnmount() {
    // this.setState({
    //   time: null,
    // })
    // window.removeEventListener("scroll", this.handleScroll)
    // clearTimeout(this.state.time)
  // }
//   handleScroll = () => {
//     const el = document.getElementById("company-video-wrap")
//     let elTop = el.getBoundingClientRect().top
//     if (!this.state.time && elTop < 150 && elTop > -150) {
//       let time = setTimeout(() => {
//         el.scrollIntoView(false)
//       }, 300)
//       this.setState({ time })
//     } else if (this.state.time && (elTop > 150 || elTop === 150 || elTop < -150)) {
//       clearTimeout(this.state.time)
//       this.setState({
//         time: null,
//       })
//     }
//   }

  doOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }
  getLifePic = (index) => {
    this.setState({
      currentLifeIdx: index,
    })
  }
  getYoungPic = (index) => {
    let i = 0,
      arr = []
    do {
      arr.push(document.getElementById(`player${i}`))
      i++
    } while (i < 3)
    arr.forEach((item, idx) => {
      item.pause()
      if (index === idx) {
        item.play()
      }
    })
    this.setState({
      currentYoungIdx: index,
    })
  }
  render() {
    return (
      <main className={`${styles.home} ${media.home}`}>
        <LxHeader></LxHeader>
        <LxSwiper list={swiperList}></LxSwiper>
        {/* 品牌 */}
        <section className='brand-section lx-hidden lx-flex-row-center'>
          <div className='lx-container lx-flex-column-center lx-pb40' style={{margin: 0}}>
            <div className='lx-fz32 lx-text-color-black lx-fwBold'>品牌公司</div>
            {/*<div className='sub-title lx-relative lx-fz22 lx-text-color-sub lx-mt10'></div>*/}
            <div className='brand-content lx-flex-row-center'>
              <div className='brand-content-left lx-flex-column-end'>
                <Brands list={brandList[0][0]} spaceFlag='spaceLeft16'></Brands>
                <Brands list={brandList[0][1]} spaceFlag='spaceLeft32'></Brands>
                <Brands list={brandList[0][2]} spaceFlag='spaceLeft32'></Brands>
              </div>
              <div className='brand-content-right'>
                <Brands list={brandList[1][0]} spaceFlag='spaceRight16'></Brands>
                <Brands list={brandList[1][1]} spaceFlag='spaceRight32'></Brands>
                <Brands list={brandList[1][2]} spaceFlag='spaceRight32'></Brands>
              </div>
            </div>
          </div>
        </section>

        {/* 中国一汽 */}
        <section className='company-section lx-bg-color-section'>
          <div className='lx-container lx-flex'>
            <div className='company-section-left lx-flex-grow-1'>
              <div className='lx-fz32 lx-text-color-black lx-fwBold lx-mb30'>中国一汽</div>
              <div className='company-intro lx-fz18'>
                中国第一汽车集团有限公司（简称中国一汽）是国有特大型汽车企业集团，
                <br />
                拥有红旗、解放、奔腾等自主品牌和大众、奥迪、捷达、丰田等合资品牌，
                <br />
                销量规模位列中国汽车行业第一阵营。
              </div>
            </div>
            <div className='company-section-right lx-relative lx-flex-row'>
              <div className={`lx-flex-grow-1 company-inner-left lx-relative lx-flex-column`}>
                <span className='lx-fz31 lx-text-color-black lx-fwBold'>FAW</span>
                <span className='lx-fz31 lx-text-color-black lx-fwBold'>企业文化</span>
              </div>
              <div className='company-inner-right lx-h100'>
                <div className='company-logo-wrap lx-fz0'>
                  <img src={yiqiLogo} alt='logo' />
                </div>
                {this.state.isOpen ? null : (
                  <div className='open-btn lx-text-center lx-pointer lx-mt30' onClick={() => this.doOpen()}>
                    <svg t='1657266916118' className='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='1688' width='24' height='24'>
                      <path d='M507.8 727.728a30.016 30.016 0 0 1-21.288-8.824L231.104 463.496a30.088 30.088 0 0 1 0-42.568 30.088 30.088 0 0 1 42.568 0l234.128 234.128 234.16-234.128a30.088 30.088 0 0 1 42.568 0 30.088 30.088 0 0 1 0 42.568L529.08 718.904a30 30 0 0 1-21.28 8.824z' p-id='1689'></path>
                    </svg>
                  </div>
                )}
              </div>
              <div className={`open-control lx-hidden ${this.state.isOpen ? "toBottom" : "toTop"}`}>
                <p className='company-group-remark lx-fz16'>
                  <span className='lx-block lx-fwBold lx-fz23 lx-mb10'>使命</span>
                  牢记嘱托&nbsp;担当使命
                  <br />
                  掌控关键核心技术
                  <br />
                  树立民族汽车品牌
                  <br />
                  打造世界一流企业
                </p>
                <p className='company-group-des lx-fz16'>
                  <span className='lx-block lx-fwBold lx-fz23 lx-mb10'>愿景</span>
                  <span>打造用创新的产品和服务不断创造价值的世界一流移动出行科技公司</span>
                </p>

                {this.state.isOpen ? (
                  <div className='open-btn lx-pointer lx-mt10 lx-text-center' onClick={() => this.doOpen()}>
                    <svg t='1657270938924' className='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2706' width='24' height='24'>
                      <path d='M516.2 296.272a30.016 30.016 0 0 1 21.28799999 8.824L792.896 560.504a30.088 30.088 0 0 1 0 42.568 30.088 30.088 0 0 1-42.568 0l-234.128-234.128-234.16 234.128a30.088 30.088 0 0 1-42.568 0 30.088 30.088 0 0 1 0-42.568L494.92 305.096a30 30 0 0 1 21.28-8.824z' p-id='2707'></path>
                    </svg>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className='company-video-wrap lx-flex-row-center lx-hidden lx-fz0' id='company-video-wrap'>
            <video className='company-video lx-h100' muted controls autoPlay loop controlsList='nodownload'>
              <source src='https://video.hotjob.cn/30ee4706954771f188b46732b68f0102/7393dea79a684b8f83a1bd0559af8b03-c4d3c6ad73d291c8959164f98131f984-ld.mp4' type='video/mp4'></source>
            </video>
          </div>
        </section>

        {/* 为什么选择中国一汽？ */}
        <section className='section-life lx-hidden'>
          <div className='lx-container'>
            <div className='section-life-title lx-fz30 lx-text-color-black lx-fw600 lx-mt15 lx-mb35'>为什么选择中国一汽？</div>
            <div className='section-life-content lx-flex-row'>
              <div className='section-life-content-left'>
                {/* <p className="section-content-tit lx-fz22">
                                    全方位贴心关爱<br/>
                                    你的生活
                                </p> */}
                <LifeYoung list={lifeList} current={this.getLifePic}></LifeYoung>
              </div>
              <div className='section-life-img lx-fz0 lx-ml50'>
                <img className='lx-h100' src={this.state.lifePics[this.state.currentLifeIdx]} alt='img' />
              </div>
            </div>
          </div>
        </section>
        {/* 完善的薪酬福利 */}
        <section className='section-young lx-hidden'>
          <div className='lx-container'>
            <div className='section-young-title lx-fz30 lx-text-color-black lx-fw600 lx-mt65 lx-mb35'>完善的薪酬福利</div>
            <div className='section-young-content lx-flex-row'>
              <div className='section-young-video lx-fz0 lx-mr50'>
                <div className='young-video-container lx-flex-row lx-h100' style={{ transform: `translateX(-${this.state.currentYoungIdx * 100}%)` }}>
                  {this.state.youngVideos.map((item, index) => {
                    return (
                      <video key={index} className='young-video lx-h100' id={`player${index}`} muted autoPlay={index === 0 ? true : false} controls loop controlsList='nodownload'>
                        <source src={item} type='video/mp4'></source>
                      </video>
                    )
                  })}
                </div>
              </div>
              <div className='section-young-content-left'>
                {/* <p className="section-content-tit lx-fz22">
                                    在自由平等的环境<br/>
                                    里工作
                                </p> */}
                <LifeYoung list={youngList} current={this.getYoungPic}></LifeYoung>
              </div>
            </div>
          </div>
        </section>
      </main>
    )
  }
}

export default Home
